<template>
  <div class="container has-text-centered" ref="container">
    <section>
      <div class="columns is-mobile is-centered">
        <div class="column is-5-desktop">
          <form @submit.prevent="manualSearch">
            <b-field label="">
              <b-autocomplete
                :data="data"
                autofocus
                :placeholder="
                  `${$t('home.index.searchPlaceholder', {
                    query: queryExample
                  })}`
                "
                field="title"
                v-model="search"
                icon-right="search"
                icon-right-clickable
                @icon-right-click="manualSearch"
                class="is-small-desktop"
                @keydown.native.enter="manualSearch"
                :loading="isFetching"
                @typing="getAsyncData"
                @select="option => pickedItem(option)"
              >
                <template slot-scope="props">
                  <div class="media">
                    <div class="media-left">
                      <img
                        width="120"
                        :src="mediaPath(props.option.document.thumbnailPath)"
                      />
                    </div>
                    <div class="media-content has-text-left">
                      {{ props.option.document.title }}
                      <br />
                      <small>
                        ID {{ props.option.document.id }},
                        {{ props.option.document.location }}
                        <b>{{ props.option.document.category }}</b>
                      </small>
                    </div>
                  </div>
                </template>
                <template #empty>{{ searchMessage }}</template>
              </b-autocomplete>
            </b-field>
          </form>
        </div>
      </div>
    </section>

    <div class="mt-5">
      <router-link :to="{ name: 'Items' }"
        ><button class="button is-primary">
          {{ $t("home.index.seeAllOurAuctions") }}
        </button></router-link
      >
    </div>

    <!-- <div class="notification m-5 is-secondary">
      <p class="subtitle">
        {{ $t("general.motd.xmasOpeningHours") }} <b>09:00-15:00</b>.
      </p>
      <p class="subtitle">
        {{ $t("general.motd.merryXmas") }}
      </p>
      <img src="@/assets/img/christmas.png" />
    </div>
    -->

    <div
      class="is-divider"
      :data-content="`${$t('home.index.PROMOTED_AUCTIONS')}`"
      v-if="promoted.length > 0"
    ></div>

    <div class="columns is-multiline is-gapless is-mobile">
      <ItemBox
        v-for="item in promoted"
        v-bind:item="item"
        v-bind:key="item.id"
        v-bind:isLoading="isLoading"
        columns="3"
      ></ItemBox>
    </div>

    <div class="columns">
      <div class="column is-half">
        <div
          class="is-divider"
          :data-content="`${$t('home.index.READYFORSALE')}`"
          v-if="readyForSale.length > 0"
        ></div>

        <ItemList
          v-for="item in readyForSale"
          v-bind:item="item"
          v-bind:key="item.id"
          v-bind:isLoading="isLoading"
        ></ItemList>
      </div>
      <div class="column is-half">
        <div
          class="is-divider"
          :data-content="`${$t('home.index.LASTBID')}`"
          v-if="newBids.length > 0"
        ></div>

        <ItemList
          v-for="item in newBids"
          v-bind:item="item"
          v-bind:key="item.id"
          v-bind:isLoading="isLoading"
        ></ItemList>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import ItemBox from "./widget/Box";
import ItemList from "./widget/List";
import debounce from "lodash/debounce";
import helpers from "../../helpers";
import isMobile from "mobile-device-detect";
import _ from "lodash";

export default {
  name: "Home",
  mixins: [helpers],
  components: {
    ItemBox,
    ItemList
  },

  data() {
    let queryExamples = [
      "Bilmerke",
      "Tesla",
      "Fiat",
      "Mercedes",
      "Opel",
      "Veteran",
      "Motorsykkel",
      "SUV",
      "ATV",
      "CAT",
      "Buss",
      "Dumper",
      "Henger",
      "Betalingsterminal",
      "Kjøkken",
      "Kasseutstyr",
      "Stasjonsvogn",
      "Campingvogn",
      "Kran",
      "Sykler",
      "Butikk"
    ];

    return {
      toggle: false,
      isLoading: false,
      newBids: [],
      newObjects: [],
      promoted: [],
      readyForSale: [],
      data: [],
      selected: null,
      isFetching: false,
      search: null,
      searchMessage: null,
      queryExample:
        queryExamples[
          Math.floor(Math.random() * (queryExamples.length - 0) + 0)
        ]
    };
  },

  created() {
    this.isLoading = true;
    this.retrieveDocs();
  },

  methods: {
    retrieveDocs() {
      const db = this.$firebase.firestore();
      const docsTimeout = setTimeout(() => {
        this.isLoading = false;
      }, 4000);

      db.collection("settings")
        .doc("liveObjects")
        .onSnapshot(snap => {
          if (snap.data()) {
            clearInterval(docsTimeout);
            let allItems = snap.data();

            // set default values to avoid undefined errors
            allItems.newBids = _.get(allItems, "newBids", []);
            allItems.newObjects = _.get(allItems, "newObjects", []);
            allItems.promoted = _.get(allItems, "promoted", []);
            allItems.readyForSale = _.get(allItems, "readyForSale", []);

            // TODO: changeable setting from admin
            this.newBids = allItems.newBids.slice(0, isMobile.isMobile ? 4 : 8);
            this.newObjects = allItems.newObjects.slice(
              0,
              isMobile.isMobile ? 4 : 8
            );
            this.promoted = allItems.promoted.slice(
              0,
              isMobile.isMobile ? 4 : 6
            );
            this.readyForSale = allItems.readyForSale.slice(
              0,
              isMobile.isMobile ? 4 : 8
            );

            this.isLoading = false;
          }
        });
    },
    manualSearch() {
      if (this.search) {
        if (this.validIdLookup(this.search)) {
          this.$router.push({
            name: "Item",
            params: { item: this.search }
          });
        } else {
          this.$router.push({
            name: "Items",
            query: { q: this.search }
          });
        }
      }
    },
    pickedItem(item) {
      this.$router.push({
        name: "Item",
        params: { item: item.document.id }
      });
    },

    getAsyncData: debounce(function(name) {
      if (!name.length) {
        this.data = [];
        this.searchMessage = null;
        return;
      }

      this.searchMessage = "Ser etter objekter...";
      this.isFetching = true;
      this.$axios
        .get(`${window.apiURL}/items`, {
          params: {
            q: name
          }
        })
        .then(({ data }) => {
          this.data = [];
          data.items.forEach(item => this.data.push(item));
          if (this.data.length > 0) {
            this.searchMessage = null;
          } else {
            this.searchMessage = "Fant ingen objekter";
          }
        })
        .catch(error => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    }, 500)
  }
};
</script>
<style lang="scss">
.is-divider[data-content]::after {
  color: #333;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.3rem 1.2rem;
}
</style>
